<template>
  <div class="collect-page">
    <div class="mains-content">
      <div class="page-left">
        <div class="member-box">
          <member
            ref="memberSearch"
            :mobile="formMobile"
            :isHand="isHand"
            @handleChange="memberChange"
          ></member>
        </div>

        <div class="right-box">
          <div
            v-if="listSelected.length == 0 ? true : false"
            class="right-box-empty"
          >
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/fooBath_empty.png" alt="" />
            </div>
          </div>
          <div v-else>
            <p class="shoping-titles">消费明细</p>
            <div class="contents-body">
              <el-row class="tables-title">
                <el-col :span="8" class="titles">
                  <div class="goodName">商品名称</div>
                </el-col>
                <el-col :span="5" class="titles center">原价</el-col>
                <el-col :span="5" class="titles center">数量</el-col>
                <el-col :span="4" class="titles center">小计</el-col>
                <el-col :span="2" class="titles right">操作</el-col>
              </el-row>
              <div class="tables p30 scroll-auto">
                <div
                  class="boxs"
                  v-for="(item, index) in listSelected"
                  :key="index"
                >
                  <el-row>
                    <el-col :span="8" class="titles">
                      <div class="goodName fb">{{ item.name }}</div>
                    </el-col>
                    <el-col :span="5" class="center fb">
                      <el-input
                        class="fontSize16"
                        size="mini"
                        v-if="item.priceType == 'floating'"
                        v-model="item.moneys"
                        :placeholder="item.priceRange"
                        @input="dbclickBox"
                        @keyup.native="item.moneys = isMoney(item.moneys)"
                      ></el-input>
                      <div v-else>
                        <span
                          class="item_line"
                          v-if="item.salePrice != item.salePriceOld"
                          >{{ item.salePriceOld }}</span
                        >
                        <span
                          :class="[
                            item.salePrice != item.salePriceOld
                              ? 'moneys ml5'
                              : '',
                          ]"
                          >{{ item.salePrice }}</span
                        >
                        <span
                          @click="showPrice(item)"
                          v-if="
                            isChangePrice == 'yes' &&
                              item.priceType != 'floating'
                          "
                          class="el-icon-edit-outline jishi cur ml5"
                        ></span>
                      </div>
                    </el-col>
                    <el-col :span="5" class="nums center">
                      <span class="del-img" @click="blurItem('del', item)">
                        <img src="../../../assets/images/new/del.png" alt="" />
                      </span>
                      <el-input
                        v-model="item.itemNum"
                        readonly=""
                        size="mini"
                        style="width: 40px;"
                      ></el-input>
                      <span class="del-img" @click="blurItem('add', item)">
                        <img src="../../../assets/images/new/add.png" alt="" />
                      </span>
                    </el-col>
                    <el-col :span="4" class="titles center fb fontSize18">{{
                      item.priceType == 'floating'
                        ? (item.moneys * item.itemNum).toFixed(2) || 0
                        : (item.itemNum * item.salePrice).toFixed(2)
                    }}</el-col>
                    <el-col :span="2" class="detail right">
                      <i
                        class="el-icon-delete delete"
                        @click="deleteListSelected(item, index)"
                      ></i>
                    </el-col>
                  </el-row>
                  <div class="right-content p10">
                    <span class="color666 fontSize16 mr10">服务技师 :</span>
                    <span
                      v-if="item.staffIds.length == 0"
                      @click="setStaff(item, index)"
                      class="shopClass"
                      >请选择></span
                    >
                    <span
                      v-else
                      @click="setStaff(item, index)"
                      class="shopClass"
                      >{{ item.staffName }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="confirm-btn">
                <div class="flex-row space-between">
                  <div class="msg">
                    <div class="nums total">
                      总数量:
                      <span>{{ totalNums }}</span>
                    </div>
                    <div class="total">
                      总金额:
                      <span class="moneys fontSize20"
                        >￥<span class="fontSize28 fb">{{
                          totalAmount
                        }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button class="save_btn" @click="saveMoney">确定开单</el-button>
      </div>
      <div class="left-box">
        <div class="tabs">
          <div class="flex-row serveNav">
            <div
              class="flex-row serve-box"
              :class="[!toggleFlag ? 'tabActive' : 'jishi']"
              @click="handleServe"
            >
              <div class="serve-img">
                <img
                  src="../../../assets/images/new/serve.png"
                  alt=""
                  v-show="!toggleFlag"
                />
                <img
                  src="../../../assets/images/new/serve_active.png"
                  alt=""
                  v-show="toggleFlag"
                />
              </div>
              <div>服务</div>
            </div>
            <div
              class="flex-row serve-box"
              :class="[toggleFlag ? 'tabActive' : 'jishi']"
              @click="handleProduct"
            >
              <div class="serve-img">
                <img
                  src="../../../assets/images/new/product_active.png"
                  alt=""
                  v-show="!toggleFlag"
                />
                <img
                  src="../../../assets/images/new/product.png"
                  alt=""
                  v-show="toggleFlag"
                />
              </div>
              <div>产品</div>
            </div>
          </div>
          <div style="display: flex;width: 60%;" class="mb10 ml20">
            <el-input
              v-model="value"
              placeholder="请输入商品名称"
              clearable
              @keyup.enter.native="clearGoods(false)"
              @clear="clearGoods"
            ></el-input>
            <el-button type="primary" class="ml10" @click="clearGoods(false)"
              >搜索</el-button
            >
            <el-button type="default" class="ml10" @click="clearGoods"
              >清空</el-button
            >
          </div>
          <!-- 历史记录 -->
          <div
            class="history ml20 mb10"
            style="display: flex;font-size: 14px;color: #333;cursor: pointer;"
          >
            <div
              v-for="(i, idx) in serveHistoryList"
              :key="idx"
              class="mr20"
              @mousedown.prevent="chooseName(i)"
            >
              <span>{{ i }}</span>
              <i
                class="el-icon-error"
                style="margin-left: 5px;"
                @mousedown.stop="removeTag(i)"
              ></i>
            </div>
          </div>
          <div class="content flex-row">
            <div
              class="tab-title"
              :class="[item.show ? 'active' : '']"
              v-for="(item, index) in toggleList"
              :key="index"
              @click="handleLeftBox(item, index)"
            >
              <span>{{ item.name }}</span>
            </div>
          </div>
          <!-- <div class="back el-icon-back" @click="back"></div> -->
          <div class="screening">
            <div class="screening-icon" @click="isSort">
              价格
              <span class="screening_img" v-if="!isSortFlag"
                ><img src="../../../assets/images/new/defaultSort.png" alt=""
              /></span>

              <span class="screening_img" v-else-if="isSortFlag && sortFlag"
                ><img src="../../../assets/images/new/screeningDown.png" alt=""
              /></span>

              <span class="screening_img" v-else-if="isSortFlag && !sortFlag"
                ><img src="../../../assets/images/new/upScreen.png" alt=""
              /></span>
            </div>
          </div>
        </div>
        <div class="tabs-content scroll-auto">
          <div v-if="!toggleFlag" class="card-boxs">
            <div
              class="card-box"
              v-for="(item, index) in list"
              :key="'serve' + index"
              :style="{
                display: activeName == 'serve' ? 'flex' : 'none',
              }"
              @click="handleSelected(item, index)"
            >
              <div v-if="item.status == 'enable'">
                <div class="card-msg" :class="item.show ? 'active' : ''">
                  <!-- <el-image style="height: 111px;width: 111px;" :src="item.imgUrl?item.imgUrl:notImg"></el-image> -->
                  <div class="msgs-content">
                    <p class="names">{{ item.name }}</p>
                    <div
                      class="serve_time"
                      :class="[item.serveDuration ? 'opacity1' : 'opacity0']"
                    >
                      <span class="serve_time_img">
                        <img src="../../../assets/images/new/time.png" alt="" />
                      </span>
                      {{ item.serveDuration }}分钟
                    </div>
                    <div class="flex-row" style="align-items: center;">
                      <p class="money">
                        ￥{{
                          item.priceType == 'floating'
                            ? item.priceRange
                            : item.salePrice
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-boxs" v-else>
            <div
              class="card-box"
              v-for="(item, index) in productList"
              :key="'product' + index"
            >
              <div
                @click="handleSelectedProduct(item, index)"
                v-if="item.status == 'enable'"
                :style="{
                  display: activeName == 'product' ? 'flex' : 'none',
                }"
              >
                <div class="card-msg" :class="item.show ? 'active' : ''">
                  <!-- <el-image style="height: 111px;width: 111px;" :src="item.imgUrl?item.imgUrl:notImg"></el-image> -->
                  <div class="msgs-content">
                    <p class="names">{{ item.name }}</p>
                    <div class="flex-row" style="align-items: center;">
                      <p class="money">
                        ￥{{
                          item.priceType == 'floating'
                            ? item.priceRange
                            : item.salePrice
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="mains-bottom">
          <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doPageQuery"></paging>
        </div>-->
      </div>
    </div>

    <div class="shopServe">
      <el-dialog :visible.sync="dialogVisible" width="800px">
        <i
          class="el-icon-close"
          @click="dialogVisible = false"
          style="position: absolute;"
        ></i>
        <div class="block">
          <el-image
            v-if="shopExpired"
            style="margin:0 235px;"
            :src="expiredImg"
          ></el-image>
        </div>

        <div class="block">
          <p
            style="margin: 0 auto;width:240px;margin-top: 36px;font-size: 30px;font-family: PingFang SC;font-weight: bold;color: #111111;line-height: 48px;"
          >
            {{ expiredHint.tipTitle }}
          </p>
        </div>
        <div class="block" style="margin-top: 10px;" v-if="shopExpired">
          <p
            v-html="expiredHint.tipContent"
            style="margin: 0 auto;width:503px;font-size: 18px;text-align:center;font-family: PingFang SC;font-weight: 500;color: #666666;line-height: 30px;"
          ></p>
        </div>

        <div class="block" style="margin-top: 35px;">
          <div style="margin: 0 auto;width: 282px;">
            <el-button
              @click="dialogVisible = false"
              style="width: 136px;height: 46px;"
              >知道了</el-button
            >
            <el-button
              type="primary"
              style="width: 136px;height: 46px;"
              @click="immediateRenewal"
              >立即续费</el-button
            >
          </div>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="smsDialogVisible" width="800px">
        <i
          class="el-icon-close"
          @click="smsDialogVisible = false"
          style="position: absolute;"
        ></i>
        <div class="block">
          <el-image
            style="width: 100%; height: 100%"
            :src="smsExpiredImg"
          ></el-image>
        </div>

        <div class="block">
          <p
            style="margin: 0 auto;width:240px;margin-top: 36px;font-size: 30px;font-family: PingFang SC;font-weight: bold;color: #111111;line-height: 48px;"
          >
            {{ smsExpiredHint.tipTitle }}
          </p>
        </div>

        <div class="block" style="margin-top: 10px;">
          <p
            v-html="smsExpiredHint.tipContent"
            style="margin: 0 auto;width:440px;font-size: 18px;text-align:center;font-family: PingFang SC;font-weight: 500;color: #666666;line-height: 30px;"
          ></p>
        </div>

        <div class="block" style="margin-top: 35px;">
          <div style="margin: 0 auto;width: 282px;">
            <el-button
              @click="smsDialogVisible = false"
              style="width: 136px;height: 46px;"
              >知道了</el-button
            >
            <el-button
              type="primary"
              style="width: 136px;height: 46px;"
              @click="
                smsDialogVisible = false;
                $router.push('/manage/shopServeed?type=sms');
              "
              >立即续费</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>

    <staff-set
      ref="staffSetForm"
      :isCashier="true"
      @staffChange="changePage"
    ></staff-set>
    <pay-success
      ref="paySuccessForm"
      @change="onChange"
      v-if="payFlag"
    ></pay-success>
  </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js';
import staffSet from '../../components/staff-set';
import member from '../../components/member';
import paySuccess from './pay';
export default {
  mixins: [minxin],
  components: { staffSet, member, paySuccess },
  data() {
    return {
      showHistory: false,
      formMobile: '',
      staffName: '',
      expiredHint: {},
      smsExpiredHint: {},
      shopExpired: false,
      smsDialogVisible: false,
      dialogVisible: false,
      pageHeight: this.$store.getters.MainHeight,
      totalNums: 0,
      totalAmount: 0,
      expiredImg: '',
      activeName: 'serve',
      tabs: [
        {
          id: '0',
          type: 'serve',
          name: '服务',
          show: true,
        },
        {
          id: '1',
          type: 'product',
          name: '产品',
          show: false,
        },
      ],
      serveGoryList: [], //服务分类
      list: [],
      productGoryList: [],
      productList: [],
      listSelected: [],
      form: {
        memberId: '',
        orderId: '',
        orderItemList: [],
      },
      idx: 0,
      popFlag: false,
      price: '',
      sortFlag: false,
      isSortFlag: false,
      userInfo: {
        shopBizConfig: {},
      },
      toggleList: [],
      toggleFlag: false,
      smsExpiredImg: '',
      payFlag: true,
      isHand: true,
      isChangePrice: false,
      value: '', // 筛选
      serveHistoryList: [],
      categoryId: '',
    };
  },
  created() {
    this.serveCategory();
    this.productCategory();
    this.userInfo = this.$store.getters.ShopInfo;
    window.addEventListener('beforeunload', this.beforeunloadHandler, false);
    this.getConfig();
    if (JSON.parse(localStorage.getItem('productHistoryList'))) {
      this.serveHistoryList =
        JSON.parse(localStorage.getItem('productHistoryList')) || [];
    }
  },
  mounted() {
    this.listSelected = [];
    if (!this.userInfo.shopId) {
      setTimeout(() => {
        this.isShopServeExpired();
      }, 1000);
    } else {
      this.isShopServeExpired();
    }
  },
  destroyed() {
    localStorage.removeItem('orderId');
    window.removeEventListener('beforeunload', this.beforeunloadHandler, false);
  },
  methods: {
    beforeunloadHandler(e) {
      // 监听网页刷新事件
      sessionStorage.removeItem('productFootBathMobile');
    },
    getConfig() {
      this.$api.get(this.$url.shop.getConfig).then((res) => {
        if (res) {
          this.isChangePrice = res.modifyPriceFlag;
        }
      });
    },
    isShopServeExpired() {
      console.log('isShopServeExpired');
      let shopId = this.userInfo.shopId;
      console.log(shopId);
      let cookieName = shopId + '-serverCookie';
      let serverCookie = this.$cookies.get(cookieName);
      console.log(serverCookie);
      if (serverCookie == null) {
        //去判断
        //判断门店服务是否到期
        this.$api.get(this.$url.shop.getExceedInfo).then((res) => {
          if (res) {
            if (res.showTip) {
              //到期
              this.expiredHint = res;
              this.expiredImg = require('../../../assets/images/expired.png');
              let tempStr = this.expiredHint.tipContent;
              tempStr = tempStr.replace(
                'tipFormatContent',
                "<span style='color:#FF8E2B;'>" +
                  this.expiredHint.tipFormatContent +
                  '</span>'
              );
              tempStr = tempStr.substring(0, tempStr.length - 1);
              this.expiredHint.tipContent = tempStr;
              this.shopExpired = true;
              this.dialogVisible = true;
            }
          }
        });

        //判断短信次数是否耗尽
        this.$api.get(this.$url.shop.getSmsNotEnoughInfo).then((res) => {
          if (res) {
            if (res.showTip) {
              //短信提示
              this.smsExpiredHint = res;
              this.smsExpiredImg = require('../../../assets/images/mobile.png');
              let tempStr = this.smsExpiredHint.tipContent;
              tempStr = tempStr.replace(
                'tipFormatContent',
                "<span style='color:#FF8E2B;'>" +
                  this.smsExpiredHint.tipFormatContent +
                  '</span>'
              );
              this.smsExpiredHint.tipContent = tempStr;
              this.smsDialogVisible = true;
            }
          }
        });

        this.$cookies.set(cookieName, 'hahahaha', 60 * 60 * 24); //60 * 60 * 24
      }
    },
    remakHide(val) {
      let a = val.priceType == 'floating' ? val.priceRange : val.salePrice;
      this.price = JSON.parse(JSON.stringify(a));
    },
    // 修改金额
    updateRemark(item) {
      // this.getList();
      if (!this.price) return;
      item.priceRange = this.price;
      item.salePrice = this.price;
      this.popFlag = false;
    },
    priceReplace() {
      if (isNaN(this.price)) {
        this.price = this.price.substr(0, this.price.length - 1);
      }
    },
    memberChange(value) {
      this.form.memberId = value;
    },
    showPrice(item) {
      this.$prompt('修改价格', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        center: true,
        inputValue:
          item.priceType == 'floating' ? item.priceRange : item.salePrice,
        inputPlaceholder: '最大9位数，小数点后只能有两位',
        inputValidator: function(value) {
          let a = true;
          if (!/^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/.test(value)) {
            a = false;
          } else if (value.length > 9) {
            a = false;
          }
          return a;
        },
        inputErrorMessage: '金额不正确或最大限制9位数',
      })
        .then(({ value }) => {
          if (!value) return;
          if (value.length > 9)
            return this.$message.warning('最大可输入9位数字');
          item.priceRange = value;
          item.salePrice = value;
          console.log(item);
          this.dbclickBox();
        })
        .catch(() => {});
    },

    handleLeftBox(tab, index) {
      console.log(tab);
      this.list = [];
      this.activeName = tab.types;
      this.categoryId = tab.id;
      if (tab.types == 'serve') {
        for (let i in this.serveGoryList) {
          this.serveGoryList[i].show = false;
        }
        this.serveGoryList[index].show = true;
        this.serveList(tab.id);
      } else {
        for (let i in this.productGoryList) {
          this.productGoryList[i].show = false;
        }
        this.productGoryList[index].show = true;
        this.productListFun(tab.id);
      }
    },
    handleServe() {
      // 点击服务
      for (let i in this.serveGoryList) {
        this.serveGoryList[i].show = false;
      }
      this.serveGoryList[0].show = true;
      this.activeName = 'serve';
      this.toggleFlag = false;
      this.toggleList = this.serveGoryList;
      this.serveList(this.toggleList[0].id);
    },
    handleProduct() {
      // 点击产品
      for (let i in this.productGoryList) {
        this.productGoryList[i].show = false;
      }
      this.productGoryList[0].show = true;
      this.activeName = 'product';
      this.toggleFlag = true;
      this.toggleList = this.productGoryList;
      this.productListFun(this.toggleList[0].id);
    },
    dbclickBox() {
      this.totalAmount = 0;
      this.totalNums = 0;
      for (let i in this.listSelected) {
        if (this.listSelected[i].priceType == 'fixed') {
          this.totalAmount +=
            this.listSelected[i].itemNum * this.listSelected[i].salePrice;
        } else {
          this.totalAmount +=
            this.listSelected[i].itemNum * this.listSelected[i].moneys;
        }
        this.totalNums += this.listSelected[i].itemNum;
      }
      this.totalAmount = this.totalAmount.toFixed(2);
    },
    deleteListSelected(item, index) {
      item.itemNum = Number(1);
      this.listSelected.splice(index, 1);
      this.dbclickBox();
    },
    setStaff(row, index) {
      this.$refs['staffSetForm'].$emit('set', {
        staffIds: row.staffIds,
        index: index,
      });
    },
    changePage(org) {
      if (org.staffIds) {
        let arr = [];
        org.staffIds.map((item) => {
          arr.push(item.staffName);
        });
        this.staffName = arr.join(',') + '>';
        this.$set(this.listSelected[org.nodeId], 'staffIds', org.staffIds);
        this.$set(this.listSelected[org.nodeId], 'staffName', this.staffName);
      }
    },
    handleSelected(item, index) {
      item.itemType = 'serve';
      item.salePriceOld = item.salePrice;
      let msg = JSON.parse(JSON.stringify(item));
      if (item.priceType == 'floating') {
        this.listSelected.push(msg);
      } else if (item.priceType == 'fixed') {
        msg.idx = this.idx;
        this.listSelected.push(msg);
        this.dbclickBox();
      }
      this.dbclickBox();
    },
    handleSelectedProduct(row) {
      console.log(row);
      row.itemType = 'product';
      row.staffIds = [];
      row.salePriceOld = row.salePrice;
      this.listSelected.push(JSON.parse(JSON.stringify(row)));
      this.dbclickBox();
    },
    handleChangeNumber() {
      this.totalAmount = 0;

      for (let i in this.listSelected) {
        let num = this.listSelected[i].priceRange
          ? this.listSelected[i].priceRange
          : this.listSelected[i].salePrice;
        this.totalAmount += this.listSelected[i].itemNum * num;
      }
    },
    dbclickBox() {
      this.totalAmount = 0;
      this.totalNums = 0;
      for (let i in this.listSelected) {
        let num =
          this.listSelected[i].priceRange == 'floating'
            ? this.listSelected[i].priceRange
            : this.listSelected[i].salePrice;
        if (this.listSelected[i].priceType == 'floating') {
          this.listSelected[i].moneys = this.isMoney(
            this.listSelected[i].moneys
          );
          console.log(
            Number(this.listSelected[i].moneys) * this.listSelected[i].itemNum
          );
          this.totalAmount +=
            Number(this.listSelected[i].moneys) * this.listSelected[i].itemNum;
          this.totalNums += 1;
        } else {
          this.totalAmount += Number(this.listSelected[i].itemNum * num);
          this.totalNums += Number(this.listSelected[i].itemNum);
        }
      }
      let arr = Number(this.totalAmount).toFixed(2);
      this.totalAmount = arr;
    },
    onChange(org) {
      this.payFlag = false;
      if (org) {
        console.log(org);
        this.listSelected = [];
        this.form = {
          memberId: '',
          orderId: '',
          orderItemList: [],
        };
        this.formMobile = '';
        this.handleServe();
        this.$refs.memberSearch.handleInputHide();
        this.totalNums = 0;
        this.totalAmount = 0;
      }
    },
    saveMoney() {
      if (sessionStorage.getItem('productFootBathMobile')) {
        return this.$message.error('请选择会员');
      }
      this.payFlag = true;
      if (this.listSelected.length < 1) {
        this.$message.warning('请添加消费');
        return false;
      }
      console.log(this.listSelected);
      for (let i in this.listSelected) {
        if (this.listSelected[i].priceType == 'floating') {
          let msg = this.listSelected[i].priceRange.split('-');
          if (
            this.listSelected[i].moneys == '0' &&
            !this.userInfo.shopBizConfig.changePriceFlag
          ) {
            if (Number(msg[0]) > 0) {
              this.$message.warning(this.listSelected[i].name + ' 金额不能为0');
              return false;
            }
          } else if (this.listSelected[i].moneys == '') {
            this.$message.warning(this.listSelected[i].name + ' 请输入金额');
            return false;
          } else if (
            this.listSelected[i].priceType == 'floating' &&
            Number(this.listSelected[i].moneys) < Number(msg[0]) &&
            !this.userInfo.shopBizConfig.changePriceFlag
          ) {
            this.$message.warning('金额不能少于' + msg[0]);
            return false;
          } else if (
            this.listSelected[i].priceType == 'floating' &&
            Number(this.listSelected[i].moneys) > Number(msg[1]) &&
            !this.userInfo.shopBizConfig.changePriceFlag
          ) {
            console.log(this.listSelected[i].moneys, msg[1]);
            this.$message.warning('金额不能超过最大值' + msg[1]);
            return false;
          }
        }
        if (this.listSelected[i].staffIds.length < 1) {
          this.$message.warning(this.listSelected[i].name + ' 请选择技师');
          return false;
        }
      }
      this.form.orderItemList = this.listSelected;
      let arrIds = '',
        arrNames = '',
        obj = [];
      for (let i in this.form.orderItemList) {
        for (let j in this.form.orderItemList[i].staffIds) {
          if (j == 0) {
            arrIds = this.form.orderItemList[i].staffIds[j].staffId;
            arrNames = this.form.orderItemList[i].staffIds[j].staffName;
          } else {
            arrIds += ',' + this.form.orderItemList[i].staffIds[j].staffId;
            arrNames += ',' + this.form.orderItemList[i].staffIds[j].staffName;
          }
        }

        obj.push({
          itemId: this.form.orderItemList[i].id,
          itemType: this.form.orderItemList[i].itemType,
          itemNum: this.form.orderItemList[i].itemNum,
          salePrice:
            this.form.orderItemList[i].priceType == 'floating'
              ? this.form.orderItemList[i].moneys
              : this.form.orderItemList[i].salePrice,
          staffIds: arrIds,
          staffNames: arrNames,
        });
      }
      this.form.orderItemList = obj;
      this.form.sourceFrom = 'order';
      if (!this.form.repeatToken) {
        this.$api.get(this.$url.order.getToken).then((res) => {
          console.log(res);
          if (res) {
            this.form.repeatToken = res;
            this.$refs['paySuccessForm'].$emit('set', this.form);
          }
        });
      } else {
        this.$refs['paySuccessForm'].$emit('set', this.form);
      }
    },
    serveCategory() {
      //分类用的后台的接口
      this.serveGoryList = [];
      let arr = [];
      this.$api
        .post(this.$url.serveCategory.list, {
          size: 100,
        })
        .then((res) => {
          if (res) {
            arr = res;
            arr.unshift({
              name: '全部服务',
              id: '',
              title: true,
            });
            for (let i in arr) {
              this.$set(arr[i], 'show', false);
              this.$set(arr[i], 'types', 'serve');
            }
            this.$set(arr[0], 'show', true);
            for (let i in arr) {
              this.serveGoryList.push(arr[i]);
            }
            this.toggleList = this.serveGoryList;
            this.serveList(this.serveGoryList[0].id);
          }
        });
    },
    productCategory() {
      this.productGoryList = [];
      let productArr = [];
      this.$api
        .post(this.$url.productCategory.list, { size: 100 })
        .then((res) => {
          if (res) {
            productArr = res;
            productArr.unshift({
              name: '全部产品',
              id: '',
              title: true,
            });
            for (let i in productArr) {
              this.$set(productArr[i], 'show', false);
              this.$set(productArr[i], 'types', 'product');
            }
            this.$set(productArr[0], 'show', true);
            console.log(productArr);
            this.productGoryList = productArr;
          }
        });
    },
    // 失去焦点的时候 数量变为1
    blurItem(type, item) {
      if (type == 'del') {
        if (item.itemNum > 1) item.itemNum--;
      } else {
        if (item.itemNum >= 99) return;
        item.itemNum++;
      }
      this.dbclickBox();
    },
    serveList(id) {
      this.list = [];
      this.$api
        .post(this.$url.serve.list, {
          size: 500,
          categoryId: id ? id : '',
          lastUpdateTime: 0,
          name: '',
          source: 'internal',
        })
        .then((res) => {
          if (res) {
            res.map((item) => {
              if (item.status == 'enable') {
                this.list.push(item);
              }
            });
            this.list.forEach((item, index) => {
              this.$set(item, 'itemNum', 1);
              this.$set(item, 'moneys', '');
              this.$set(item, 'staffIds', []);
            });
            if (this.isSortFlag) this.screeningClick(this.list);
          }
          if (this.value) {
            console.log('xxx');
            this.filterData();
          }
        });
    },
    productListFun(id) {
      this.productList = [];
      this.$api
        .post(this.$url.product.list, {
          size: 500,
          categoryId: id,
          lastUpdateTime: 0,
          name: '',
          source: 'internal',
        })
        .then((res) => {
          if (res) {
            res.map((item) => {
              if (item.status == 'enable') {
                this.productList.push(item);
              }
            });
            this.productList.forEach((item, index) => {
              this.$set(item, 'itemNum', 1);
              this.$set(item, 'moneys', '');
              this.$set(item, 'staffIds', []);
            });
            if (this.isSortFlag) this.screeningClick(this.productList);
          }
          if (this.value) {
            this.filterData();
          }
        });
    },
    isSort() {
      this.sortFlag = !this.sortFlag;
      this.isSortFlag = true;
      this.screeningClick();
    },
    screeningClick(list) {
      if (list) {
        if (this.activeName == 'serve') {
          this.list = this.sortFlag ? this.bigSort(list) : this.smallSort(list);
        } else {
          this.productList = this.sortFlag
            ? this.bigSort(list)
            : this.smallSort(list);
        }
      } else {
        if (this.activeName == 'serve') {
          this.list = this.sortFlag
            ? this.bigSort(this.list)
            : this.smallSort(this.list);
        } else {
          this.productList = this.sortFlag
            ? this.bigSort(this.productList)
            : this.smallSort(this.productList);
        }
      }
      this.$forceUpdate();
    },
    smallSort(a) {
      // this.sortFlag
      var b = 0;
      for (var i = 0; i < a.length; i++) {
        for (var j = 0; j < a.length; j++) {
          if (j >= a.length - 1) break;
          let a1 =
            a[j].priceType == 'fixed'
              ? a[j].salePrice
              : a[j].priceRange.split('-')[0];
          let a2 =
            a[j + 1].priceType == 'fixed'
              ? a[j + 1].salePrice
              : a[j + 1].priceRange.split('-')[0];
          if (Number(a1) > Number(a2)) {
            b = a[j];
            a[j] = a[j + 1];
            a[j + 1] = b;
          }
        }
      }
      return a;
    },
    bigSort(a) {
      var b = 0;
      for (var i = 0; i < a.length; i++) {
        for (var j = 0; j < a.length; j++) {
          if (j >= a.length - 1) break;
          let a1 =
            a[j].priceType == 'fixed'
              ? a[j].salePrice
              : a[j].priceRange.split('-')[0];
          let a2 =
            a[j + 1].priceType == 'fixed'
              ? a[j + 1].salePrice
              : a[j + 1].priceRange.split('-')[0];
          if (Number(a1) < Number(a2)) {
            b = a[j];
            a[j] = a[j + 1];
            a[j + 1] = b;
          }
        }
      }
      return a;
    },
    immediateRenewal() {
      this.dialogVisible = false;
      this.$router.push('/manage/shopServeed?type=shopManage');
    },
    filterData() {
      if (this.value) {
        //  // 服务
        if (!this.toggleFlag) {
          this.boxList = this.fuzzyQuery(this.list, this.value);
          console.log(this.boxList);
          this.list = this.boxList;
        } else {
          this.boxList = this.fuzzyQuery(this.productList, this.value);
          console.log(this.boxList);
          this.productList = this.boxList;
        }
        this.setHistoryList();
      } else {
        this.clearGoods();
      }
    },
    setHistoryList() {
      if (this.serveHistoryList.includes(this.value)) {
        this.serveHistoryList = this.serveHistoryList.filter((item) => {
          return item !== this.value;
        });
        this.serveHistoryList.unshift(this.value);
        localStorage.setItem(
          'productHistoryList',
          JSON.stringify(this.serveHistoryList)
        );
        return;
      }
      if (this.serveHistoryList.length >= 3) {
        this.serveHistoryList.pop();
      }
      this.serveHistoryList.unshift(this.value);
      localStorage.setItem(
        'productHistoryList',
        JSON.stringify(this.serveHistoryList)
      );
    },
    fuzzyQuery(list, keyWord) {
      var reg = new RegExp(keyWord);
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].name)) {
          arr.push(list[i]);
        }
      }
      return arr;
    },
    clearGoods(val) {
      if (val) this.value = '';

      if (this.activeName == 'serve') {
        this.serveList(this.categoryId);
      } else if (this.activeName == 'product') {
        this.productListFun(this.categoryId);
      }
    },
    chooseName(item) {
      this.value = item;
      this.clearGoods(false);
    },
    removeTag(item) {
      let idx = this.serveHistoryList.indexOf(item);
      if (idx != -1) {
        this.serveHistoryList.splice(idx, 1);
        localStorage.setItem(
          'productHistoryList',
          JSON.stringify(this.serveHistoryList)
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/edit.less';
@tabsColor: #4e89f8;

.fontWeight {
  font-weight: 700;
}

.collect-page {
  padding: 0 16px;
  background-color: #e6edf5;
}

.mains-content {
  display: flex;
  height: 100%;
  margin: 16px 0;

  .left-box {
    width: 60%;
    // display: flex;
    // flex-wrap: wrap;
    overflow: hidden;
    position: relative;

    .serveNav {
      padding: 16px 0 16px 16px;
    }

    .tabs {
      position: relative;
      background: white;
      border-right: 1px solid #eee;
      margin-bottom: 8px;
      border-radius: 10px 10px 0px 0px;

      .screening {
        position: absolute;
        right: 10px;
        bottom: 0;
        text-align: center;

        .screening-icon {
          // width: 60px;
          display: flex;
          cursor: pointer;
          padding: 15px;

          .screening_img {
            display: inline-block;
            width: 14px;
            height: 14px;
          }

          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
            margin-left: 5px;
          }
        }
      }

      .content {
        width: 800px;
        max-width: 800px;
        display: flex;
        padding-left: 30px;
        border-bottom: 1px solid #ebedf0;
        overflow-x: auto;
      }
      .content::-webkit-scrollbar  {
        width: 5px;
        height: 5px; // 高度写不写，都不影响，因为会根据内容的长度自动计算
      }

      .content::-webkit-scrollbar-thumb {
        background: #ccc; // 滑块颜色
        border-radius: 5px; // 滑块圆角
      }

      .tab-title {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        min-width: max-content;
        overflow: auto;
        margin-right: 40px;
        padding-bottom: 10px;
        cursor: pointer;

        &:hover {
          border-bottom: 3px solid #3388ff;
          border-radius: 3px 3px 0px 0px;
          color: @tabsColor;
        }
      }

      .active {
        border-bottom: 3px solid #3388ff;
        border-radius: 3px 3px 0px 0px;
        color: @tabsColor;
      }
    }

    .mains-bottom {
      position: absolute;
      bottom: 0;
      left: 106px;
      background: #fff;
      z-index: 1;
      height: 63px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid @borderColor;
      width: calc(100% - 106px);
      box-sizing: border-box;
    }

    .tabs-content {
      flex: 1;
      position: relative;
      box-sizing: border-box;

      .card-boxs {
        display: flex;
        flex-wrap: wrap;
        max-height: calc(100vh - 260px);
        overflow: auto;

        .card-box {
          width: calc(19% - 30px);
          margin-right: 1%;
          height: 88px;
          padding: 15px;
          background: url('../../../assets/images/new/footBath_box.png')
            no-repeat;
          background-size: 100% 100%;
          margin-bottom: 8px;
          cursor: pointer;

          &:nth-of-type(5n) {
            margin-right: 0 !important;
          }
        }

        .card-msg {
          // width: 110px;
          // height: 50px;

          // justify-content: space-between;

          .msgs-content {
            height: 48px;
            padding: 3px 5px 0;

            .serve_time {
              padding: 3px 0;
              color: #aaa;
              font-size: 14px;

              .serve_time_img {
                display: inline-block;
                width: 20px;
                height: 20px;
                margin-right: 3px;

                img {
                  width: 100%;
                  height: 100%;
                  vertical-align: middle;
                }
              }
            }
          }

          /deep/ .el-image img {
            height: 111px;
          }

          .names {
            font-size: 16px;
            margin-bottom: 20px;
            flex: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .money {
            font-size: 18px;
            color: @money;
            font-weight: bold;
          }

          .icons {
            text-align: right;

            .icon {
              flex: 1;
              width: 14px;
              text-align: center;
              height: 14px;
              line-height: 14px;
              border: 1px solid #000;
              color: #000;
              border-radius: 50%;
              float: right;
              font-size: 14px;
            }
          }
        }

        // .noMargin {
        // 	margin-right: 0;
        // }
      }
    }
  }

  .member-box {
    width: calc(100% - 48px);
    padding: 15px 16px;
    background: #3388ff;
    border-radius: 10px 10px 0px 0px;
  }

  .page-left {
    width: 40%;
  }

  .right-box {
    background: url('../../../assets/images/new/footBath.png') no-repeat;
    background-position: center bottom;
    margin-right: 16px;

    .right-box-empty {
      height: calc(100vh - 255px);
      display: flex;
      justify-content: center;
      align-items: center;

      .right-box-empty-img {
        width: 191px;
        height: 170px;
      }
    }

    .shoping-titles {
      padding: 16px;
      font-size: 18px;
      font-weight: 700;
    }

    .contents-body {
      .tables-title {
        padding: 13px 16px;
        font-size: 14px;
        background: #f7f8fa;
      }

      .tables {
        padding: 0 0 16px;
        height: calc(100vh - 430px);
        box-sizing: border-box;

        .boxs {
          padding: 18px 16px 0;
          box-sizing: border-box;

          &:hover {
            border-left: 3px solid #3388ff;
            background: #f3f8fe;
          }

          .money {
            color: @money;
            font-weight: 500;
          }

          .nums {
            display: flex;
            justify-content: center;

            .del-img {
              width: 28px;
              height: 28px;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
              }
            }

            /deep/ .el-input__inner {
              border-radius: inherit;
              text-align: center;
              padding: 0;
              border-left: none;
              border-right: none;
            }
          }

          .delete {
            font-size: 18px;
            cursor: pointer;

            &:hover {
              color: @blue;
            }
          }
        }

        .right-content {
          margin-top: 15px;
          display: flex;
          padding-bottom: 16px;
          border-bottom: 1px solid #ebedf0;
        }
      }

      .confirm-btn {
        display: flex;
        align-items: center;
        margin: 0 16px;
        border-top: 1px solid #ebedf0;
        padding: 12px 0;

        .flex-row {
          width: 100%;
          align-items: center;

          .msg {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            font-weight: 500;

            .nums {
              line-height: 3;
              margin-right: 40px;
            }
          }
        }
      }
    }
  }

  .serve-box {
    width: 84px;
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    justify-content: center;
    border-radius: 16px;
    margin-right: 16px;
    color: #fff;
    cursor: pointer;
    // background: #3388FF;
    background: #e6f7ff;

    img {
      width: 100%;
      vertical-align: middle;
    }

    .serve-img {
      margin-right: 6px;
    }
  }

  .tabActive {
    color: #fff;
    background-color: #3388ff;
  }
}

.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #ff5449;
}

.goodName {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.el-icon-close {
  margin: 20px 19px 505px 766px;
  font-size: 16px;
  z-index: 1;
  cursor: pointer;
}

.shopServe /deep/ .el-dialog {
  height: 550px !important;
  position: relative;
}

.shopServe /deep/ .el-dialog__body {
  padding: 0 0;
}

.shopServe /deep/ .el-dialog__header {
  display: none;
}
</style>
